import { render } from "./StatisticSummary.vue?vue&type=template&id=2f5a8396&ts=true"
import script from "./StatisticSummary.vue?vue&type=script&lang=ts"
export * from "./StatisticSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__